function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { sdkLogger } from '../../logger';
import { Observable } from '../../utils/observables/observable';
import { TrackableEvent } from './session-controller.enums';
export { TrackableEvent } from './session-controller.enums';
export var SessionEventTracker = /*#__PURE__*/ function() {
    "use strict";
    function SessionEventTracker(sessionProxy) {
        _class_call_check(this, SessionEventTracker);
        _define_property(this, "sessionProxy", void 0);
        _define_property(this, "trackedDataObservable", void 0);
        _define_property(this, "observedEventTypes", void 0);
        _define_property(this, "trackedData", void 0);
        _define_property(this, "availableAudioTracks", void 0);
        _define_property(this, "logger", void 0);
        this.sessionProxy = sessionProxy;
        this.trackedDataObservable = new Observable();
        this.observedEventTypes = new Set();
        var _obj;
        this.trackedData = (_obj = {}, _define_property(_obj, TrackableEvent.VideoTrackChanged, []), _define_property(_obj, TrackableEvent.AudioTrackChanged, []), _define_property(_obj, TrackableEvent.SessionStateChanged, []), _obj);
        this.availableAudioTracks = [];
        this.logger = sdkLogger.withContext('Session Event Tracker');
        this.sessionProxy.onSessionEnded(this.handleSessionEnded.bind(this));
    }
    _create_class(SessionEventTracker, [
        {
            key: "requestEventTracking",
            value: function requestEventTracking(eventTypes, callback, owner) {
                var _this = this;
                eventTypes.forEach(function(ev) {
                    if (_this.observedEventTypes.has(ev)) {
                        return;
                    }
                    _this.registerSessionObserver(ev);
                    _this.observedEventTypes.add(ev);
                });
                this.trackedDataObservable.registerObserver(callback, owner);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(owner) {
                this.trackedDataObservable.unregisterObservers(owner);
            }
        },
        {
            key: "registerSessionObserver",
            value: function registerSessionObserver(ev) {
                switch(ev){
                    case TrackableEvent.VideoTrackChanged:
                        this.sessionProxy.onVideoTrackChanged(this.handleVideoTrackChanged.bind(this));
                        return;
                    case TrackableEvent.AudioTrackChanged:
                        this.sessionProxy.onAvailableAudioTracksChanged(this.handleAvailableAudioTracksChanged.bind(this));
                        this.sessionProxy.onAudioTrackChanged(this.handleAudioTrackChanged.bind(this));
                        return;
                    case TrackableEvent.SessionStateChanged:
                        this.sessionProxy.onStateChanged(this.handleSessionStateChanged.bind(this));
                        return;
                }
            }
        },
        {
            key: "handleVideoTrackChanged",
            value: function handleVideoTrackChanged(videoTrack) {
                var event = this.timestamp({
                    videoTrack: videoTrack
                });
                this.trackedData[TrackableEvent.VideoTrackChanged].push(event);
            }
        },
        {
            key: "handleAvailableAudioTracksChanged",
            value: function handleAvailableAudioTracksChanged(availableAudioTracks) {
                this.availableAudioTracks = availableAudioTracks;
            }
        },
        {
            key: "handleAudioTrackChanged",
            value: function handleAudioTrackChanged(trackId) {
                var audioTrack = this.availableAudioTracks.find(function(t) {
                    return t.id === trackId;
                });
                if (!audioTrack) {
                    this.logger.warn("Received an audio track ID which didn't match any available audio tracks");
                    return;
                }
                var event = this.timestamp({
                    audioTrack: audioTrack
                });
                this.trackedData[TrackableEvent.AudioTrackChanged].push(event);
            }
        },
        {
            key: "handleSessionStateChanged",
            value: function handleSessionStateChanged(state) {
                var event = this.timestamp({
                    state: state
                });
                this.trackedData[TrackableEvent.SessionStateChanged].push(event);
            }
        },
        {
            key: "timestamp",
            value: function timestamp(data) {
                return _object_spread_props(_object_spread({}, data), {
                    timestamp: Date.now()
                });
            }
        },
        {
            key: "handleSessionEnded",
            value: function handleSessionEnded() {
                if (!this.trackedDataObservable) {
                    this.logger.warn('Unable to notify because destroy was called before the session was ended');
                    return;
                }
                this.trackedDataObservable.notifyObservers(this.trackedData);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.trackedDataObservable = undefined;
                this.observedEventTypes = undefined;
                this.trackedData = undefined;
                this.availableAudioTracks = undefined;
                this.sessionProxy = undefined;
            }
        }
    ]);
    return SessionEventTracker;
}();

//# sourceMappingURL=session-event-tracker.js.map